/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getRewardProfile} from '../api'

 export const useQueryGetRewardProfile = createReactQueryHook('getRewardProfile', getRewardProfile)
